import { render, staticRenderFns } from "./LinkPaymentPreview.vue?vue&type=template&id=642f94f6&"
import script from "./LinkPaymentPreview.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LinkPaymentPreview.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports